// extracted by mini-css-extract-plugin
module.exports = {"root":"view-header_root_2IIUd","button":"view-header_button_2HEIu","active":"view-header_active_1k0Ld","btnExport":"view-header_btnExport_sRiFU","mr":"view-header_mr_3LyE6"};